// Helper pro tisk dodacích listů — otevře nové okno se stylovaným HTML a spustí window.print()
// groups: [{
//   branchName: string,
//   branchAddress?: string,
//   items: [{ productName, quantity (ks), unitMode, unitCount, packageSize, packageLabel, note? }],
//   totalPieces: number,
//   dispatchIds: string[],
// }]

const escapeHtml = (s) =>
  String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

const fmtQty = (n) => {
  const x = Math.round(Number(n || 0) * 100) / 100;
  return Number.isInteger(x) ? String(x) : x.toFixed(2);
};

const renderItemQty = (it) => {
  // Custom alt-unit nebo legacy package
  if (it.unitMode && it.unitMode !== "piece" && it.unitCount) {
    const label = it.unitMode === "package"
      ? (it.packageLabel || "balení")
      : it.unitMode;
    return `${fmtQty(it.unitCount)} ${escapeHtml(label)} <span class="muted">(${fmtQty(it.quantity)} ks)</span>`;
  }
  if (it.packageSize > 1) {
    const pkgs = it.quantity / it.packageSize;
    if (Number.isInteger(pkgs) && pkgs > 0) {
      return `${fmtQty(it.quantity)} ks <span class="muted">(${fmtQty(pkgs)} ${escapeHtml(it.packageLabel || "balení")})</span>`;
    }
  }
  return `${fmtQty(it.quantity)} ks`;
};

const renderNote = (date) => {
  const d = new Date(date);
  return `${d.toLocaleDateString("cs-CZ", { day: "2-digit", month: "2-digit", year: "numeric" })}`;
};

const noteHtml = ({ branchName, branchAddress, items, totalPieces, dispatchIds, date }) => {
  const dlNumber = `DL-${date.replace(/-/g, "")}-${(branchName || "").replace(/[^A-Za-z0-9]/g, "").slice(0, 6).toUpperCase()}`;
  return `
  <section class="dn">
    <header class="dn-head">
      <div class="brand">
        <div class="brand-name">Caféčko</div>
        <div class="brand-sub">Dodací list</div>
      </div>
      <div class="meta">
        <div><span class="lbl">Číslo:</span><span class="val mono">${escapeHtml(dlNumber)}</span></div>
        <div><span class="lbl">Datum:</span><span class="val">${renderNote(date)}</span></div>
      </div>
    </header>

    <div class="parties">
      <div class="party">
        <div class="party-lbl">Dodavatel</div>
        <div class="party-name">Caféčko</div>
        <div class="party-line">Centrální výroba</div>
      </div>
      <div class="party">
        <div class="party-lbl">Příjemce</div>
        <div class="party-name">${escapeHtml(branchName)}</div>
        ${branchAddress ? `<div class="party-line">${escapeHtml(branchAddress)}</div>` : ""}
      </div>
    </div>

    <table class="items">
      <thead>
        <tr>
          <th class="num">#</th>
          <th>Výrobek</th>
          <th class="right">Množství</th>
        </tr>
      </thead>
      <tbody>
        ${items
          .map(
            (it, i) => `
          <tr>
            <td class="num">${i + 1}</td>
            <td>
              <div class="prod-name">${escapeHtml(it.productName)}</div>
              ${it.note ? `<div class="muted">${escapeHtml(it.note)}</div>` : ""}
            </td>
            <td class="right mono">${renderItemQty(it)}</td>
          </tr>`
          )
          .join("")}
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td class="right strong">Celkem kusů</td>
          <td class="right mono strong">${fmtQty(totalPieces)} ks</td>
        </tr>
      </tfoot>
    </table>

    <div class="signs">
      <div class="sign">
        <div class="sign-line"></div>
        <div class="sign-lbl">Předal (Caféčko)</div>
      </div>
      <div class="sign">
        <div class="sign-line"></div>
        <div class="sign-lbl">Převzal (${escapeHtml(branchName)})</div>
      </div>
    </div>

    <div class="footnote muted">
      Položky pocházejí z expedic: ${dispatchIds.map((x) => `<span class="mono">${escapeHtml(x.slice(0, 8))}</span>`).join(", ")}
    </div>
  </section>`;
};

const STYLE = `
  * { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; background: #FFFFFF; color: #1C1917; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; }
  .wrap { padding: 0; }
  .dn { padding: 28px 32px; max-width: 760px; margin: 0 auto; page-break-after: always; }
  .dn:last-child { page-break-after: auto; }
  .dn-head { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #3A2D27; padding-bottom: 14px; margin-bottom: 18px; }
  .brand-name { font-family: 'Georgia', serif; font-size: 28px; font-weight: 700; letter-spacing: 0.5px; color: #3A2D27; }
  .brand-sub { font-size: 12px; text-transform: uppercase; letter-spacing: 2px; color: #57534E; margin-top: 2px; }
  .meta { text-align: right; font-size: 13px; }
  .meta div { margin-bottom: 4px; }
  .meta .lbl { color: #57534E; margin-right: 8px; text-transform: uppercase; font-size: 11px; letter-spacing: 1px; }
  .meta .val { font-weight: 600; }
  .parties { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin-bottom: 24px; }
  .party-lbl { font-size: 11px; text-transform: uppercase; letter-spacing: 1.5px; color: #57534E; margin-bottom: 6px; }
  .party-name { font-size: 16px; font-weight: 600; margin-bottom: 2px; }
  .party-line { font-size: 13px; color: #57534E; }
  table.items { width: 100%; border-collapse: collapse; margin-top: 6px; }
  table.items th, table.items td { padding: 10px 8px; font-size: 13px; vertical-align: top; }
  table.items thead th { border-bottom: 2px solid #3A2D27; text-align: left; font-size: 11px; text-transform: uppercase; letter-spacing: 1px; color: #57534E; }
  table.items tbody tr { border-bottom: 1px solid #E5E1D8; }
  table.items .num { width: 36px; color: #57534E; }
  table.items .right { text-align: right; }
  table.items .prod-name { font-weight: 500; }
  table.items tfoot td { border-top: 2px solid #3A2D27; font-size: 14px; padding-top: 12px; }
  .strong { font-weight: 700; }
  .mono { font-family: 'Menlo', 'Courier New', monospace; }
  .muted { color: #57534E; font-size: 12px; }
  .signs { display: grid; grid-template-columns: 1fr 1fr; gap: 32px; margin-top: 56px; }
  .sign-line { border-bottom: 1px solid #1C1917; height: 32px; }
  .sign-lbl { font-size: 11px; text-transform: uppercase; letter-spacing: 1.5px; color: #57534E; margin-top: 6px; text-align: center; }
  .footnote { margin-top: 24px; font-size: 11px; text-align: center; }
  @media print {
    @page { size: A4; margin: 14mm; }
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  }
`;

export function printDeliveryNotes(groups, date) {
  if (!groups || groups.length === 0) return;
  const html = `<!doctype html>
  <html lang="cs">
  <head>
    <meta charset="utf-8" />
    <title>Dodací list — ${date}</title>
    <style>${STYLE}</style>
  </head>
  <body>
    <div class="wrap">
      ${groups.map((g) => noteHtml({ ...g, date })).join("")}
    </div>
    <script>
      window.addEventListener('load', function() {
        setTimeout(function() { window.focus(); window.print(); }, 150);
      });
    </script>
  </body>
  </html>`;

  const win = window.open("", "_blank", "width=900,height=1100");
  if (!win) {
    alert("Vyskakovací okno bylo zablokováno. Povolte pop-up okna a zkuste to znovu.");
    return;
  }
  win.document.open();
  win.document.write(html);
  win.document.close();
}
